const state = {
    currentPlaceId: '', //当前站点id,
    list: [],
};

const mutations = {
    CHANGE_PLACE: (state, placeId) => {
        state.currentPlaceId = placeId;
    }
};

const actions = {
    changePlace({commit}, placeId) {
        commit('CHANGE_PLACE', placeId);
    },
};

export default {
    state,
    mutations,
    actions
};
